const ACCESS_TOKEN = 'accessToken'
const REFRESH_TOKEN = 'refreshToken'
const PLUGIN_TYPE = 'pluginType'
const BASE_URL = 'baseUrl'
const ONBOARDING = 'onboarding'
const INSTANCE_SETUP = 'instanceSetup'
const ATLASSIAN_BASE_URL = 'atlassianBaseUrl'
const IS_PLUGIN_ADMIN = 'isPluginAdmin'
const BACKEND_VERSION = 'backendVersion'
const API_BASE = 'apiBase'
const ROUTER_BASE = 'routerBase'
const ISS = 'iss'
const PRODUCTION = 'production'
const ORGANIZATION_ID = 'organizationId'
const WEB_APP_URL = 'webAppUrl'
const WEB_APP_LOGIN_URL = 'webAppLoginUrl'
const WEB_APP_CONNECTED = 'webAppConnected'
const JIRA_CONNECTED = 'jiraConnected'
const CREATE_ORGANIZATION = 'createOrganization'
const DASHBOARD_ITEM_ID = 'dashboardItemId'
const DASHBOARD_PAGE_ID = 'dashboardPageId'
const VERSION = 'version'
const JIRA_ISSUE_ID = 'jiraIssueId'
const SETUP_NAME = 'setupName'
const IS_OWNER = 'isOwner'
const SUBSCRIPTION_PLAN = 'subscriptionPlan'
const LICENSE_STATUS_ID = 'licenseStatusId'
const LICENSE_STATUS_DAYS_LEFT = 'licenseStatusDaysLeft'
const INSTANCE_STATE_ID = 'instanceStateId'
const DISABLED_MODULES = 'disabledModules'
const EXTERNAL_PLATFORM_ID = 'externalPlatformId'
const LICENSE_TYPE = 'licenseType'
const OBOARD_APP_ID = 'oboardAppId'
const PARAMS = 'params'
const SUCCESS = 'success'
const TEMPLATE_NAME = 'templateName'

const PLUGIN_OPTIONS_KEYS = {
  PLUGIN_TYPE: PLUGIN_TYPE,
  BASE_URL: BASE_URL,
  ONBOARDING: ONBOARDING,
  INSTANCE_SETUP: INSTANCE_SETUP,
  CREATE_ORGANIZATION: CREATE_ORGANIZATION,
  ATLASSIAN_BASE_URL: ATLASSIAN_BASE_URL,
  IS_PLUGIN_ADMIN: IS_PLUGIN_ADMIN,
  LICENSE_STATUS_ID: LICENSE_STATUS_ID,
  LICENSE_STATUS_DAYS_LEFT: LICENSE_STATUS_DAYS_LEFT,
  BACKEND_VERSION: BACKEND_VERSION,
  WEB_APP_CONNECTED: WEB_APP_CONNECTED,
  JIRA_CONNECTED: JIRA_CONNECTED,
  SETUP_NAME: SETUP_NAME,
  IS_OWNER: IS_OWNER,
  SUBSCRIPTION_PLAN: SUBSCRIPTION_PLAN,
  INSTANCE_STATE_ID: INSTANCE_STATE_ID,
  ISS: ISS
}

const CREATE_AUTH_APP_PLUGIN_OPTIONS = [
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  ...Object.values(PLUGIN_OPTIONS_KEYS)
]

const CREATE_AUTH_APP_PLUGIN_OPTIONS_OBJECT = Object.fromEntries(
  CREATE_AUTH_APP_PLUGIN_OPTIONS.map(key => [key, key])
)

const JIRA_APP_PLUGIN_OPTIONS = [
  API_BASE,
  ROUTER_BASE,
  PLUGIN_TYPE,
  ISS,
  BASE_URL,
  ATLASSIAN_BASE_URL,
  PRODUCTION,
  WEB_APP_URL,
  WEB_APP_LOGIN_URL,
  DISABLED_MODULES
]

const WEB_APP_PLUGIN_OPTIONS = [
  API_BASE,
  ROUTER_BASE,
  PLUGIN_TYPE,
  ISS,
  BASE_URL,
  ATLASSIAN_BASE_URL,
  PRODUCTION,
  ORGANIZATION_ID,
  WEB_APP_URL,
  WEB_APP_LOGIN_URL,
  DISABLED_MODULES
]

const CROSS_PLATFORM_PLUGIN_OPTIONS = [...WEB_APP_PLUGIN_OPTIONS, EXTERNAL_PLATFORM_ID]

const CONFLUENCE_APP_PLUGIN_OPTIONS = [
  REFRESH_TOKEN,
  PLUGIN_TYPE,
  BASE_URL,
  API_BASE,
  ONBOARDING,
  ATLASSIAN_BASE_URL,
  IS_PLUGIN_ADMIN,
  ACCESS_TOKEN,
  PRODUCTION,
  TEMPLATE_NAME
]

const CONFLUENCE_MACRO_PLUGIN_OPTIONS = [
  ATLASSIAN_BASE_URL,
  BASE_URL,
  API_BASE,
  PLUGIN_TYPE,
  ISS,
  PRODUCTION,
  TEMPLATE_NAME
]

const GADGET_PLUGIN_OPTIONS = [
  DASHBOARD_ITEM_ID,
  DASHBOARD_PAGE_ID,
  ATLASSIAN_BASE_URL,
  BASE_URL,
  API_BASE,
  PLUGIN_TYPE,
  ISS,
  PRODUCTION
]

const JIRA_ISSUE_SIDEBAR_PLUGIN_OPTIONS = [
  JIRA_ISSUE_ID,
  BASE_URL,
  API_BASE,
  PLUGIN_TYPE,
  ISS,
  ATLASSIAN_BASE_URL,
  PRODUCTION
]

const LOGIN_APP_PLUGIN_OPTIONS = [API_BASE, WEB_APP_URL, WEB_APP_LOGIN_URL]

const SSO_REQUIRED_APP_PLUGIN_OPTIONS = [API_BASE, WEB_APP_URL, WEB_APP_LOGIN_URL]

const AFTER_LOGIN_MS_APP_PLUGIN_OPTIONS = [SUCCESS]

const CROSS_PLATFORM_INSTALLATION_APP_PLUGIN_OPTIONS = [API_BASE, ORGANIZATION_ID]

const COMMON_BOOLEAN_KEYS = [IS_PLUGIN_ADMIN, ONBOARDING, INSTANCE_SETUP]

const COMMON_NUMBER_KEYS = [LICENSE_STATUS_DAYS_LEFT]

const TEMPLATE_OPTIONS_KEYS = {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  PLUGIN_TYPE,
  BASE_URL,
  ONBOARDING,
  INSTANCE_SETUP,
  ATLASSIAN_BASE_URL,
  IS_PLUGIN_ADMIN,
  BACKEND_VERSION,
  API_BASE,
  ROUTER_BASE,
  ISS,
  PRODUCTION,
  ORGANIZATION_ID,
  WEB_APP_URL,
  WEB_APP_LOGIN_URL,
  WEB_APP_CONNECTED,
  JIRA_CONNECTED,
  CREATE_ORGANIZATION,
  DASHBOARD_ITEM_ID,
  DASHBOARD_PAGE_ID,
  VERSION,
  JIRA_ISSUE_ID,
  SETUP_NAME,
  IS_OWNER,
  SUBSCRIPTION_PLAN,
  LICENSE_STATUS_ID,
  LICENSE_STATUS_DAYS_LEFT,
  INSTANCE_STATE_ID,
  DISABLED_MODULES,
  EXTERNAL_PLATFORM_ID,
  LICENSE_TYPE,
  OBOARD_APP_ID,
  PARAMS,
  SUCCESS,
  TEMPLATE_NAME
}

const COMMON_DEV_TEMPLATE_OPTIONS = {
  ACCESS_TOKEN,
  API_BASE,
  ATLASSIAN_BASE_URL,
  BACKEND_VERSION,
  BASE_URL,
  DASHBOARD_ITEM_ID,
  DASHBOARD_PAGE_ID,
  DISABLED_MODULES,
  INSTANCE_STATE_ID,
  IS_PLUGIN_ADMIN,
  ISS,
  JIRA_CONNECTED,
  JIRA_ISSUE_ID,
  LICENSE_STATUS_DAYS_LEFT,
  LICENSE_STATUS_ID,
  LICENSE_TYPE,
  ONBOARDING,
  INSTANCE_SETUP,
  PLUGIN_TYPE,
  PRODUCTION,
  REFRESH_TOKEN,
  SUBSCRIPTION_PLAN,
  WEB_APP_CONNECTED,
  WEB_APP_URL
}

const COMMON_CONFLUENCE_DEV_TEMPLATE_OPTIONS = {
  ACCESS_TOKEN,
  API_BASE,
  ATLASSIAN_BASE_URL,
  BACKEND_VERSION,
  BASE_URL,
  DASHBOARD_ITEM_ID,
  IS_PLUGIN_ADMIN,
  ISS,
  JIRA_ISSUE_ID,
  LICENSE_TYPE,
  ONBOARDING,
  PLUGIN_TYPE,
  REFRESH_TOKEN
}

const CONFLUENCE_PROD_TEMPLATE_OPTIONS = {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  BASE_URL,
  API_BASE,
  PLUGIN_TYPE,
  ATLASSIAN_BASE_URL,
  ISS,
  ONBOARDING,
  IS_PLUGIN_ADMIN,
  BACKEND_VERSION,
  PRODUCTION,
  TEMPLATE_NAME
}

const COMMON_CLOUD_PROD_TEMPLATE_OPTIONS = {
  ACCESS_TOKEN,
  API_BASE,
  ATLASSIAN_BASE_URL,
  BACKEND_VERSION,
  BASE_URL,
  DASHBOARD_ITEM_ID,
  DASHBOARD_PAGE_ID,
  DISABLED_MODULES,
  INSTANCE_STATE_ID,
  IS_PLUGIN_ADMIN,
  ISS,
  JIRA_CONNECTED,
  JIRA_ISSUE_ID,
  LICENSE_STATUS_DAYS_LEFT,
  LICENSE_STATUS_ID,
  LICENSE_TYPE,
  ONBOARDING,
  INSTANCE_SETUP,
  PLUGIN_TYPE,
  PRODUCTION,
  REFRESH_TOKEN,
  SUBSCRIPTION_PLAN,
  WEB_APP_CONNECTED,
  WEB_APP_LOGIN_URL,
  WEB_APP_URL
}

const FORGE_APP_PLUGIN_OPTIONS = {
  ...COMMON_CLOUD_PROD_TEMPLATE_OPTIONS,
  TEMPLATE_NAME
}

const AZURE_APP_PLUGIN_OPTIONS = {
  ...COMMON_CLOUD_PROD_TEMPLATE_OPTIONS,
  IS_OWNER
}

const AZURE_SETTINGS_APP_PLUGIN_OPTIONS = {
  API_BASE
}

module.exports = {
  PLUGIN_OPTIONS_KEYS,
  CREATE_AUTH_APP_PLUGIN_OPTIONS_OBJECT,
  CONFLUENCE_MACRO_PLUGIN_OPTIONS,
  DASHBOARD_ITEM_ID,
  DASHBOARD_PAGE_ID,
  VERSION,
  CREATE_AUTH_APP_PLUGIN_OPTIONS,
  JIRA_APP_PLUGIN_OPTIONS,
  WEB_APP_PLUGIN_OPTIONS,
  CROSS_PLATFORM_PLUGIN_OPTIONS,
  CONFLUENCE_APP_PLUGIN_OPTIONS,
  GADGET_PLUGIN_OPTIONS,
  JIRA_ISSUE_SIDEBAR_PLUGIN_OPTIONS,
  LOGIN_APP_PLUGIN_OPTIONS,
  SSO_REQUIRED_APP_PLUGIN_OPTIONS,
  AFTER_LOGIN_MS_APP_PLUGIN_OPTIONS,
  CROSS_PLATFORM_INSTALLATION_APP_PLUGIN_OPTIONS,
  CONFLUENCE_PROD_TEMPLATE_OPTIONS,
  COMMON_BOOLEAN_KEYS,
  COMMON_NUMBER_KEYS,
  CREATE_ORGANIZATION,
  SETUP_NAME,
  WEB_APP_CONNECTED,
  JIRA_CONNECTED,
  IS_OWNER,
  SUBSCRIPTION_PLAN,
  LICENSE_STATUS_DAYS_LEFT,
  LICENSE_STATUS_ID,
  INSTANCE_STATE_ID,
  ORGANIZATION_ID,
  EXTERNAL_PLATFORM_ID,
  TEMPLATE_OPTIONS_KEYS,
  COMMON_DEV_TEMPLATE_OPTIONS,
  COMMON_CONFLUENCE_DEV_TEMPLATE_OPTIONS,
  COMMON_CLOUD_PROD_TEMPLATE_OPTIONS,
  BACKEND_VERSION,
  WEB_APP_URL,
  WEB_APP_LOGIN_URL,
  LICENSE_TYPE,
  TEMPLATE_NAME,
  PRODUCTION,
  FORGE_APP_PLUGIN_OPTIONS,
  AZURE_APP_PLUGIN_OPTIONS,
  AZURE_SETTINGS_APP_PLUGIN_OPTIONS,
  ACCESS_TOKEN,
  REFRESH_TOKEN
}
